import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-backup',
  templateUrl: './cloud-backup.component.html',
  styleUrls: ['./cloud-backup.component.css']
})
export class CloudBackupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
